
function comments(state = [], action) {
  switch (action.type) {
    case 'SAVE_COMMENT':
      const { tsn_statement_id, who, whom, content } = action.comment;

      const filteredState = state.filter(comment => !(comment.tsn_statement_id === tsn_statement_id &&
        comment.who === who && comment.whom === whom)
      );

      return content === '' ?
        filteredState : [
          ...filteredState,
          action.comment
        ]

    case 'DATA_RECEIVED' : {
      const {
        data: {
          comments = []
        } = {}
      } = action;

      return comments
    }

    default:
      return state;
  }
}

export default comments;
